import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Outlet } from "react-router-dom";
import WeclomeSection from "./components/WeclomeSection";

function UserVerification() {
  return (
    <div className="flex full-width" style={{ overflow: "hidden" }}>
      <WeclomeSection />
      <Outlet />
    </div>
  );
}

export default UserVerification;
